import { useEffect, useRef, useState } from "react";

const STATS = [
  { num: 2022, suffix: "", label: "Anno di fondazione", duration: 1600 },
  { num: 50, suffix: "+", label: "Progetti completati", duration: 1400 },
  { num: 6, suffix: "", label: "Aree di intervento", duration: 1400 },
  { num: 30, suffix: " m", label: "Altezza operativa", duration: 1400 },
];

function useCountUp(target, duration = 1500, start = false) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!start) return;
    let raf;
    const startTime = performance.now();
    const tick = (now) => {
      const p = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration, start]);
  return value;
}

function StatItem({ stat, start, idx }) {
  const v = useCountUp(stat.num, stat.duration, start);
  return (
    <div
      data-testid={`stat-${idx}`}
      className="border-l border-slate-700 pl-6 md:pl-10 py-6"
    >
      <div className="flex items-baseline">
        <span className="text-5xl md:text-7xl lg:text-8xl font-bold text-white tabular tracking-tighter">
          {v.toLocaleString("it-IT")}
        </span>
        <span className="text-3xl md:text-5xl font-bold text-[#FF5A1F] tracking-tight">
          {stat.suffix}
        </span>
      </div>
      <div className="mt-3 text-xs md:text-sm tracking-[0.25em] uppercase text-slate-400">
        {stat.label}
      </div>
    </div>
  );
}

export default function Stats() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      data-testid="stats-section"
      className="relative bg-[#050B14] py-24 md:py-32 border-y border-[#1E293B]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-12">
          <div className="w-10 h-px bg-[#FF5A1F]" />
          <span className="text-xs tracking-[0.3em] uppercase text-[#FF5A1F] font-bold">
            Numeri
          </span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {STATS.map((s, i) => (
            <StatItem key={i} stat={s} start={visible} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
